import verifyEmail from 'api/UserController/verifyEmail';
import { ERROR_MESSAGES } from './constants';

export const isFilled = (value: string | undefined) => !!value?.trim();

export const isValidEmail = async (
  value: string | undefined,
  shouldRequestTransfer: boolean,
  isNewPage: boolean,
  existingUserEmail?: string,
) => {
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(String(value).toLowerCase())) {
    // email duplication will not be checked if user wants to request a transfer or is editing a user and not changing the email
    if (shouldRequestTransfer || (!isNewPage && value === existingUserEmail)) {
      return { isValid: true };
    }
    const { isAvailable } = await verifyEmail({ email: value });
    return {
      isValid: isAvailable,
      errorMessage: !isAvailable ? ERROR_MESSAGES.duplicateEmail : undefined,
    };
  }
  return { isValid: false, errorMessage: ERROR_MESSAGES.email };
};

export const isDate = (value: unknown) => {
  if (typeof value === 'string') {
    return !Number.isNaN(Date.parse(value));
  }
  return value instanceof Date;
};

export const isValidPassword = (value: string | undefined) => {
  if (!value) return false;
  // 8 characters, 1 letter, 1 number, 1 capital
  const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
  return re.test(value);
};
